import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { portalApi, PORTAL_TOKEN_KEY } from "@/lib/portalApi";
import { formatApiErrorDetail } from "@/lib/api";
import { portalNext } from "@/pages/PortalLogin";

export default function PortalEnter() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    portalApi
      .post("/enter", { token })
      .then(({ data }) => {
        localStorage.setItem(PORTAL_TOKEN_KEY, data.access_token);
        navigate(portalNext(null), { replace: true });
      })
      .catch((err) =>
        setError(
          formatApiErrorDetail(err.response?.data?.detail) ||
            "That link is no longer valid",
        ),
      );
  }, [token, navigate]);

  return (
    <div
      className="flex min-h-screen items-center justify-center bg-zinc-950 px-6"
      data-testid="portal-enter"
    >
      {error ? (
        <div className="max-w-sm text-center">
          <h1 className="text-base font-semibold text-zinc-100 md:text-lg">
            This link has expired
          </h1>
          <p
            className="mt-2 text-sm text-zinc-500"
            data-testid="portal-enter-error"
          >
            {error}
          </p>
          <Link
            to="/portal"
            data-testid="portal-enter-retry"
            className="mt-6 inline-block rounded-xl bg-indigo-600 px-5 py-3 text-[11px] font-bold uppercase tracking-widest text-white hover:bg-indigo-500"
          >
            Email me a new link
          </Link>
        </div>
      ) : (
        <div className="h-10 w-10 animate-pulse rounded-full bg-zinc-800" />
      )}
    </div>
  );
}
